import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import activity from './modules/activity'
import adminPanelUsers from './modules/adminPanelUsers'
import app from './modules/app'
import auth from './modules/auth'
import dashboard from './modules/dashboard'
import draft from './modules/draft'
import globalComponents from './modules/globalComponents'
import logs from './modules/logs'
import newClient from './modules/newClient'
import newProspect from './modules/newProspect'
import notifications from './modules/notifications'

const dataEventContext = createPersistedState({
  paths: ['globalComponents.eventContext'],
  key: 'eventContext',
  storage: window.localStorage,
})
const dataSessionExpiresAt = createPersistedState({
  paths: ['globalComponents.sessionExpiresAt'],
  key: 'sessionExpiresAt',
  storage: window.localStorage,
})
const dataOtpType = createPersistedState({
  paths: ['auth.otpType'],
  key: 'otpType',
  storage: window.localStorage,
})

const dataIsSecureUploadLogin = createPersistedState({
  paths: ['globalComponents.isSecureUploadLogin'],
  key: 'isSecureUploadLogin',
  storage: window.localStorage,
})

const dataTRCM = createPersistedState({
  paths: ['globalComponents.TRCMData'],
  key: 'TRCMData',
  storage: window.localStorage,
})

const dataTRCMSecrets = createPersistedState({
  paths: ['globalComponents.TRCMSecrets'],
  key: 'TRCMSecrets',
  storage: window.localStorage,
})

const dataCalendarView = createPersistedState({
  paths: ['globalComponents.calendarView'],
  key: 'calendarView',
  storage: window.localStorage,
})

const dataFloatingPopup = createPersistedState({
  // Persist only stable UI preferences for the floating popup
  paths: ['globalComponents.floatingPopup.position', 'globalComponents.floatingPopup.isMinimized'],
  key: 'floatingPopup',
  storage: window.localStorage,
})

const dataCalendarInitData = createPersistedState({
  paths: ['globalComponents.calendarInitData'],
  key: 'calendarInitData',
  storage: window.sessionStorage,
})

const dataStateAuth = createPersistedState({
  paths: ['auth.isAuth'],
  key: 'auth',
  storage: window.localStorage,
})

const dataStateAdvisorId = createPersistedState({
  paths: ['globalComponents.advisorId'],
  key: 'advisorId',
  storage: window.localStorage,
})

const dataSetMemberId = createPersistedState({
  paths: ['globalComponents.memberId'],
  key: 'memberId',
  storage: window.localStorage,
})

const dataSetMemberName = createPersistedState({
  paths: ['globalComponents.memberName'],
  key: 'memberName',
  storage: window.localStorage,
})

const dataStateMultipleAccount = createPersistedState({
  paths: ['globalComponents.multipleAccount'],
  key: 'multipleAccount',
  storage: window.localStorage,
})

const dataStateIsMultipleVerified = createPersistedState({
  paths: ['globalComponents.isMultipleVerified'],
  key: 'isMultipleVerified',
  storage: window.localStorage,
})

const dataStateSetclientId = createPersistedState({
  paths: ['globalComponents.clientId'],
  key: 'clientId',
  storage: window.localStorage,
})

const dataStateCeoId = createPersistedState({
  paths: ['globalComponents.ceoId'],
  key: 'ceoId',
  storage: window.localStorage,
})

const dataStateSuperAdminId = createPersistedState({
  paths: ['globalComponents.adminId'],
  key: 'adminId',
  storage: window.localStorage,
})

const dataStateRole = createPersistedState({
  paths: ['globalComponents.role'],
  key: 'role',
  storage: window.localStorage,
})

const dataStateCurrentCompanyId = createPersistedState({
  paths: ['globalComponents.currentCompanyId'],
  key: 'currentCompanyId',
  storage: window.localStorage,
})

const dataStateUserId = createPersistedState({
  paths: ['globalComponents.userId'],
  key: 'userId',
  storage: window.localStorage,
})

const dataStateClientId = createPersistedState({
  paths: ['globalComponents.clientId'],
  key: 'clientId',
  storage: window.localStorage,
})

const dataStateLeadId = createPersistedState({
  paths: ['globalComponents.leadId'],
  key: 'leadId',
  storage: window.localStorage,
})

const dataStateSupportId = createPersistedState({
  paths: ['globalComponents.supportId'],
  key: 'supportId',
  storage: window.localStorage,
})

const dataStateTerms = createPersistedState({
  paths: ['globalComponents.termsAndConditions'],
  key: 'termsAndConditions',
  storage: window.localStorage,
})

const dataStateTermsInfo = createPersistedState({
  paths: ['globalComponents.termsAndConditionsInfo'],
  key: 'termsAndConditionsInfo',
  storage: window.localStorage,
})

const dataStateTrcmULR = createPersistedState({
  paths: ['globalComponents.trcmURL'],
  key: 'trcmURL',
  storage: window.localStorage,
})

const dataDraft = createPersistedState({
  paths: ['draft'],
  key: 'draft',
  storage: window.localStorage,
})

const dataTotalContractValue = createPersistedState({
  paths: ['globalComponents.totalContractValue'],
  key: 'totalContractValue',
  storage: window.localStorage,
})

const dataIsClientPreview = createPersistedState({
  paths: ['globalComponents.IsClientPreview'],
  key: 'IsClientPreview',
  storage: window.localStorage,
})

const dataAwsConfig = createPersistedState({
  paths: ['globalComponents.awsConfig'],
  key: 'awsConfig',
  storage: window.localStorage,
})

const dataSecureMemberData = createPersistedState({
  paths: ['globalComponents.secureMemberData'],
  key: 'secureMemberData',
  storage: window.localStorage,
})

const dataExportDetails = createPersistedState({
  paths: ['globalComponents.exportDetails'],
  key: 'exportDetails',
  storage: window.localStorage,
})

export default createStore({
  modules: {
    app,
    auth,
    dashboard,
    newProspect,
    newClient,
    globalComponents,
    notifications,
    activity,
    logs,
    adminPanelUsers,
    draft,
    dataFloatingPopup,
  },
  plugins: [
    dataStateAuth,
    dataAwsConfig,
    dataTRCM,
    dataTRCMSecrets,
    dataSetMemberId,
    dataSetMemberName,
    dataOtpType,
    dataStateAdvisorId,
    dataStateRole,
    dataStateIsMultipleVerified,
    dataIsClientPreview,
    dataStateCurrentCompanyId,
    dataIsSecureUploadLogin,
    dataCalendarView,
    dataStateUserId,
    dataStateSetclientId,
    dataStateMultipleAccount,
    dataStateCeoId,
    dataStateSuperAdminId,
    dataTotalContractValue,
    dataStateClientId,
    dataStateLeadId,
    dataStateTerms,
    dataStateTermsInfo,
    dataStateTrcmULR,
    dataStateSupportId,
    dataSecureMemberData,
    dataDraft,
    dataCalendarInitData,
    dataSessionExpiresAt,
    dataEventContext,
    dataExportDetails,
  ],
})
